import { Accordion } from 'admin-web-ui'
import React from 'react'
import styled from 'styled-components'
import { HydratedUserInfo } from '../types'
import { DisplayList } from './components'

const EmailContent = styled.div`
  display: flex;
  gap: 4px;
`

interface Props extends Pick<HydratedUserInfo, 'userEmails'> {}

export const EmailSection: React.FC<Props> = ({ userEmails }) => {
  return userEmails?.length ? (
    <Accordion title="Email">
      <EmailContent>
        <p>Email Addresses:</p>
        <DisplayList>
          {userEmails.map((email) => (
            <a href={`mailto:${email.emailAddress}`} key={email.id}>
              {email.emailAddress}
            </a>
          ))}
        </DisplayList>
      </EmailContent>
    </Accordion>
  ) : null
}
